// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import { createValidator } from '#runtime/validation/index.ts';
import * as compiled from './auth.compiled.ts';

export const validateCreateDemoUserRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateCreateDemoUserRequestPayload,
    {},
  );
export const validateGetEmailOidcRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateGetEmailOidcRequestPayload,
    {},
  );
export const validateLoginCallbackRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateLoginCallbackRequestPayload,
    {},
  );
export const validateLoginRequestPayload = /* @__PURE__ */ createValidator(
  compiled.validateLoginRequestPayload,
  {},
);
export const validateLoginWithOidcRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateLoginWithOidcRequestPayload,
    {},
  );
export const validateRevokeRefreshTokenRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateRevokeRefreshTokenRequestPayload,
    {},
  );
export const validateSendSignInLinkToEmailRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateSendSignInLinkToEmailRequestPayload,
    {},
  );
